import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = {
  key: 1,
  class: "empty-state"
}

import { IonBadge, IonButton, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonDatetime, IonFab, IonFabButton, IonHeader, IonIcon, IonItem, IonItemDivider, IonLabel, IonList, IonMenuButton, IonModal, IonPage, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToolbar, modalController, onIonViewDidEnter, onIonViewWillLeave, alertController, popoverController } from '@ionic/vue';
import { computed, ref } from 'vue';
import { addOutline, albumsOutline, businessOutline, ellipsisVerticalOutline, globeOutline, optionsOutline, storefrontOutline, timeOutline, timerOutline } from 'ionicons/icons';
import { translate } from '@hotwax/dxp-components';
import ShopActionsPopover from '@/components/ShopActionsPopover.vue'
import CreateGroupModal from '@/components/CreateGroupModal.vue'
import LinkFacilitiesToGroupModal from '@/components/LinkFacilitiesToGroupModal.vue'
import LinkThresholdFacilitiesToGroupModal from '@/components/LinkThresholdFacilitiesToGroupModal.vue'
import { useStore } from 'vuex';
import EditGroupModal from '@/components/EditGroupModal.vue';
import emitter from '@/event-bus';
import { DateTime } from 'luxon';
import CustomFrequencyModal from "@/components/CustomFrequencyModal.vue";
import { hasError, hasJobDataError, showToast } from "@/utils";
import { ChannelService } from '@/services/ChannelService';
import logger from "@/logger";


export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryChannels',
  setup(__props) {

const store = useStore();

const inventoryChannels = computed(() => store.getters["channel/getInventoryChannels"])
const selectedSegment = computed(() => store.getters["util/getSelectedSegment"])
const shopifyJobs = computed(() => store.getters["channel/getJobs"])
const getTemporalExpr = computed(() => store.getters["channel/getTemporalExpr"])

const isDateTimeModalOpen = ref(false);
const allowedFrequencies = ref([
  {
    "id": "HOURLY",
    "description": "Hourly"
  }, {
    "id": "EVERY_6_HOUR",
    "description": "Every 6 hours"
  }, {
    "id": "EVERYDAY",
    "description": "Every day"
  }, {
    "id": "CUSTOM",
    "description": "Custom"
  }
])
const allowedRunTimes = ref([
  {
    "value": 0,
    "label": "Now"
  }, {
    "value": 300000,
    "label": "In 5 minutes"
  }, {
    "value": 900000,
    "label": "In 15 minutes"
  }, {
    "value": 3600000,
    "label": "In an hour"
  }, {
    "value": 86400000,
    "label": "Tomorrow"
  }, {
    "value": "CUSTOM",
    "label": "Custom"
  }
]);
const jobFrequencyOptions = ref([]) as any;
const jobRuntimeOptions = ref([]) as any;

onIonViewDidEnter(async() => {
  fetchInventoryChannels()
  emitter.on("productStoreOrConfigChanged", fetchInventoryChannels);
})

onIonViewWillLeave(() => {
  emitter.off("productStoreOrConfigChanged", fetchInventoryChannels);
})

async function fetchInventoryChannels() {
  emitter.emit("presentLoader");
  if(!selectedSegment.value || (selectedSegment.value !== 'channels' && selectedSegment.value !== 'publish')) store.dispatch("util/updateSelectedSegment", "channels");
  await Promise.allSettled([store.dispatch("channel/fetchInventoryChannels"), store.dispatch("util/fetchConfigFacilities")]);
  if(selectedSegment.value === "publish") {
    await Promise.allSettled([store.dispatch("channel/fetchJobs"), store.dispatch("channel/findTemporalExpression")]);
    generateFrequencyOptions();
    generateRuntimeOptions();
  }
  emitter.emit("dismissLoader");
}

async function openShopActionsPopover(event: Event, job: any) {
  const popover = await popoverController.create({
    component: ShopActionsPopover,
    componentProps: { job },
    showBackdrop: false,
    event
  });

  return popover.present();
}

async function openEditGroupModal(group: any) {
  const modal = await modalController.create({
    component: EditGroupModal,
    componentProps: { group }
  })

  modal.present()
}

async function openCreateGroupModal() {
  const popover = await modalController.create({
    component: CreateGroupModal
  });

  return popover.present();
}

async function openLinkFacilitiesToGroupModal(group: any) {
  const popover = await modalController.create({
    component: LinkFacilitiesToGroupModal,
    componentProps: { group, selectedFacilities: group.selectedFacilities }
  });

  return popover.present();
}

async function openLinkThresholdFacilitiesToGroupModal(group: any) {
  const popover = await modalController.create({
    component: LinkThresholdFacilitiesToGroupModal,
    componentProps: { group, selectedConfigFacilityId: group.selectedConfigFacility }
  });

  return popover.present();
}

function getFacilityCount(channel: any, facilityTypeId: string) {
  if(!channel.selectedFacilities?.length) return 0;

  if(facilityTypeId === 'STORE') {
    return channel.selectedFacilities.filter((facility: any) => facility.facilityTypeId === "RETAIL_STORE" || facility.facilityTypeId === "OUTLET_STORE").length;
  } else {
    return channel.selectedFacilities.filter((facility: any) => facility.facilityTypeId === "WAREHOUSE" || facility.facilityTypeId === "OUTLET_WAREHOUSE").length;
  }
}

async function updateSegment(event: any) {
  await store.dispatch("util/updateSelectedSegment", event.detail.value);
  if(selectedSegment.value === "publish") {
    await store.dispatch("channel/fetchJobs");
    await store.dispatch("channel/findTemporalExpression")
    generateFrequencyOptions()
    generateRuntimeOptions();
  }
}

function isCustomRunTime(value: number) {
  return !allowedRunTimes.value.some((runTime: any) => runTime.value === value)
}

function getJobStatus(job: any) {
  return job.statusId === "SERVICE_DRAFT" ? job.statusId : job.tempExprId;
}

function updateFrequency(event: any, job: any) {
  let selectedFrequency = event.target.value
  if(selectedFrequency === "CUSTOM") {
    setCustomFrequency(job);
    return;
  }

  job.tempExprId = selectedFrequency
}

async function setCustomFrequency(currentJob: any) {
  const customFrequencyModal = await modalController.create({
    component: CustomFrequencyModal,
  });

  await customFrequencyModal.present();

  await customFrequencyModal.onDidDismiss().then((result) => {
    if(result.data?.frequencyId) {
      currentJob.tempExprId = result.data.frequencyId
    }
    generateFrequencyOptions()
  });
}

function generateFrequencyOptions() {
  const frequencyOptions = JSON.parse(JSON.stringify(allowedFrequencies.value));

  shopifyJobs.value.map((job: any) => {
    const option = frequencyOptions.find((option: any) => option.id === job.tempExprId)
    if(!option) {
      const tempExpression = getTemporalExpr.value(job.tempExprId)
      if(tempExpression) frequencyOptions.push({ id: tempExpression.tempExprId, description: tempExpression.description });
    }
  })
  jobFrequencyOptions.value = frequencyOptions
}

function generateRuntimeOptions() {
  const runTimeOptions = JSON.parse(JSON.stringify(allowedRunTimes.value));

  shopifyJobs.value.map((job: any) => {
    if(job.statusId === "SERVICE_PENDING") {
      const selectedTime = runTimeOptions.find((option: any) => option.value === job.runTimeValue);
      if(!selectedTime) {
        runTimeOptions.push({ label: getTime(job.runTimeValue), value: job.runTimeValue })
      }
    }
  })
  jobRuntimeOptions.value = runTimeOptions
}

function updateRunTime(event: CustomEvent, currentJob: any) {
  const value = event.detail.value
  if (value != 'CUSTOM') {
    currentJob.runTimeValue = value
    generateRuntimeOptions()
  } else {
    isDateTimeModalOpen.value = true
  }
}

function updateCustomTime(event: CustomEvent, currentJob: any) {
  const currTime = DateTime.now().toMillis();
  const setTime = handleDateTimeInput(event.detail.value);
  if(setTime > currTime) {
    currentJob.runTimeValue = setTime
    generateRuntimeOptions()
  } else {
    showToast(translate("Provide a future date and time"))
  }
}

async function saveChanges(job: any) {
  const alert = await alertController
    .create({
      header: translate("Save changes"),
      message: translate("Are you sure you want to save these changes?"),
      buttons: [{
        text: translate("Cancel"),
        role: "cancel"
      }, {
        text: translate("Save"),
        handler: async() => {
          if(isCustomRunTime(job.runTimeValue) && isRuntimePassed(job)) {
            showToast(translate("Job runtime has passed. Please refresh to get the latest job data in order to perform any action."))
            return;
          }

          // return if job has missing data or error
          if(hasJobDataError(job)) return;

          job['jobStatus'] = job.tempExprId !== 'SERVICE_DRAFT' ? job.tempExprId : 'HOURLY';

          // Handling the case for 'Now'. Sending the now value will fail the API as by the time
          // the job is ran, the given 'now' time would have passed. Hence, passing empty 'run time'
          job.runTime = job.runTimeValue != 0 ? (!isCustomRunTime(job.runTimeValue) ? DateTime.now().toMillis() + job.runTimeValue : job.runTimeValue) : ''

          if (job?.statusId === 'SERVICE_DRAFT') {
            await scheduleService(job)
          } else if (job?.statusId === 'SERVICE_PENDING') {
            await updateJob(job);
            await store.dispatch('channel/updateJob', job)
          }
        }
      }]
    });
  return alert.present();
}

async function scheduleService(job: any) {
  let resp;

  const payload = {
    'JOB_NAME': job.jobName,
    'SERVICE_NAME': job.serviceName,
    'SERVICE_COUNT': '0',
    'SERVICE_TEMP_EXPR': job.jobStatus,
    'SERVICE_RUN_AS_SYSTEM':'Y',
    'jobFields': {
      'productStoreId': store.state.user.currentEComStore.productStoreId,
      'systemJobEnumId': job.systemJobEnumId,
      'tempExprId': job.jobStatus, // Need to remove this as we are passing frequency in SERVICE_TEMP_EXPR, currently kept it for backward compatibility
      'maxRecurrenceCount': '-1',
      'parentJobId': job.parentJobId,
      'runAsUser': 'system', //default system, but empty in run now.  TODO Need to remove this as we are using SERVICE_RUN_AS_SYSTEM, currently kept it for backward compatibility
      'recurrenceTimeZone': store.state.user.current.timeZone,
      'createdByUserLogin': store.state.user.current.username,
      'lastModifiedByUserLogin': store.state.user.current.username,
    },
    'statusId': "SERVICE_PENDING",
    'systemJobEnumId': job.systemJobEnumId
  } as any

  Object.keys(job.runtimeData).map((key: any) => {
    if(key !== "productStoreId" && key !== "shopifyConfigId" && key !== "shopId") {
      payload[key] = job.runtimeData[key];
    }
  })

  const jobRunTimeDataKeys = job?.runtimeData ? Object.keys(job?.runtimeData) : [];
  if (jobRunTimeDataKeys.includes('shopifyConfigId') || jobRunTimeDataKeys.includes('shopId')) {
    jobRunTimeDataKeys.includes('shopifyConfigId') && (payload['shopifyConfigId'] = job.shopifyConfigId);
    jobRunTimeDataKeys.includes('shopId') && (payload['shopId'] = job.shopId);
    payload['jobFields']['shopId'] = job.shopId;
  }

  // checking if the runtimeData has productStoreId, and if present then adding it on root level
  job?.runtimeData?.productStoreId?.length >= 0 && (payload['productStoreId'] = job.productStoreId)
  job?.priority && (payload['SERVICE_PRIORITY'] = job.priority.toString())
  job?.runTime && (payload['SERVICE_TIME'] = job.runTime.toString())

  try {
    resp = await ChannelService.scheduleJob({ ...payload });
    if (resp.status == 200 && !hasError(resp)) {
      showToast(translate("Service has been scheduled."));
      await store.dispatch("channel/fetchJobs");
      generateFrequencyOptions();
      generateRuntimeOptions();
    } else {
      throw resp.data;
    }
  } catch (err) {
    showToast(translate("Failed to schedule service."))
    logger.error(err)
  }
}

async function updateJob(job: any) {
  const payload = {
    'jobId': job.jobId,
    'systemJobEnumId': job.systemJobEnumId,
    'recurrenceTimeZone': store.state.user.current.userTimeZone,
    'tempExprId': job.jobStatus,
    'statusId': "SERVICE_PENDING",
    'runTimeEpoch': '',  // when updating a job clearning the epoch time, as job honors epoch time as runTime and the new job created also uses epoch time as runTime
    'lastModifiedByUserLogin': store.state.user.current.username
  } as any

  job?.runTime && (payload['runTime'] = job.runTime)
  job?.jobName && (payload['jobName'] = job.jobName)

  try {
    const resp = await ChannelService.updateJob(payload)
    if (!hasError(resp)) {
      showToast(translate("Service has been scheduled."))
      await store.dispatch("channel/fetchJobs");
      generateFrequencyOptions();
      generateRuntimeOptions();
    } else {
      throw resp.data;
    }
  } catch(error: any) {
    showToast(translate("Failed to schedule service."))
    logger.error(error)
  }
}

function isRuntimePassed(currentJob: any) {
  return currentJob.runTimeValue && currentJob.runTimeValue <= DateTime.now().toMillis()
}

function handleDateTimeInput(dateTimeValue: any) {
  // TODO Handle it in a better way
  // Remove timezone and then convert to timestamp
  // Current date time picker picks browser timezone and there is no supprt to change it
  const dateTime = DateTime.fromISO(dateTimeValue, { setZone: true}).toFormat("yyyy-MM-dd'T'HH:mm:ss")
  return DateTime.fromISO(dateTime).toMillis()
}

function getDateTime(time: any) {
  return DateTime.fromMillis(time).toISO()
}

const getNowTimestamp = () => {
  return DateTime.now().toISO();
}

function getTime (time: any) {
  return DateTime.fromMillis(time).toLocaleString(DateTime.DATETIME_MED);
}

function timeFromNow(time: any) {
  const timeDiff = DateTime.fromMillis(time).diff(DateTime.local());
  return DateTime.local().plus(timeDiff).toRelative();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonMenuButton), { slot: "start" }),
              _createVNode(_unref(IonTitle), { slot: "start" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Inventory channels")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegment), {
                value: selectedSegment.value,
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (updateSegment($event))),
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegmentButton), { value: "channels" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Channels")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "publish" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Publish")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            (selectedSegment.value === 'channels')
              ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                  (inventoryChannels.value.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(inventoryChannels.value, (channel) => {
                        return (_openBlock(), _createBlock(_unref(IonCard), {
                          key: channel.facilityGroupId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCardHeader), null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_unref(IonCardSubtitle), { class: "overline" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(channel.facilityGroupId), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonCardTitle), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(channel.facilityGroupName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (channel.description)
                                    ? (_openBlock(), _createBlock(_unref(IonCardSubtitle), {
                                        key: 0,
                                        innerHTML: channel.description.replace(/(?:\n|\n)/g, '<br />')
                                      }, null, 8, ["innerHTML"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonItem), { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(globeOutline)
                                }, null, 8, ["icon"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(channel.selectedConfigFacility?.facilityName) + " ", 1),
                                    _createElementVNode("p", null, _toDisplayString(channel.selectedConfigFacility?.facilityId), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(IonButton), {
                                  size: "default",
                                  slot: "end",
                                  fill: "clear",
                                  color: "medium",
                                  onClick: ($event: any) => (openLinkThresholdFacilitiesToGroupModal(channel))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      icon: _unref(optionsOutline),
                                      slot: "icon-only"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonList), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItemDivider), { color: "light" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("Facilities")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonButton), {
                                      size: "default",
                                      slot: "end",
                                      fill: "clear",
                                      color: "medium",
                                      onClick: ($event: any) => (openLinkFacilitiesToGroupModal(channel))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonIcon), {
                                          icon: _unref(optionsOutline),
                                          slot: "icon-only"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(IonItem), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      slot: "start",
                                      icon: _unref(storefrontOutline)
                                    }, null, 8, ["icon"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("retail facilities", { count: getFacilityCount(channel, "STORE") })), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(IonItem), { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      slot: "start",
                                      icon: _unref(businessOutline)
                                    }, null, 8, ["icon"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("warehouse", { count: getFacilityCount(channel, "WAREHOUSE") })), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_unref(IonButton), {
                                    fill: "clear",
                                    onClick: ($event: any) => (openEditGroupModal(channel))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(translate)("Edit group")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("p", null, _toDisplayString(_unref(translate)("No inventory channel found.")), 1)
                      ]))
                ]))
              : (selectedSegment.value === 'publish')
                ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                    (shopifyJobs.value.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(shopifyJobs.value, (job) => {
                          return (_openBlock(), _createBlock(_unref(IonCard), {
                            key: job.shopId
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCardHeader), null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_unref(IonCardSubtitle), { class: "overline" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(job.shopifyConfigId), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonCardTitle), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(job.name ? job.name : job.shopifyConfigId), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  (job.statusId === 'SERVICE_PENDING')
                                    ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                        key: 0,
                                        color: "dark"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(translate)("running")) + " " + _toDisplayString(timeFromNow(job.runTime)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(IonList), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        slot: "start",
                                        icon: _unref(timeOutline)
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonSelect), {
                                        label: _unref(translate)('Run time'),
                                        placeholder: _unref(translate)('Select'),
                                        interface: "popover",
                                        value: job.runTimeValue,
                                        onIonChange: ($event: any) => (updateRunTime($event, job))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobRuntimeOptions.value, (runTime) => {
                                            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                              key: runTime.value,
                                              value: runTime.value
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(runTime.label), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["label", "placeholder", "value", "onIonChange"]),
                                      _createVNode(_unref(IonModal), {
                                        class: "date-time-modal",
                                        "is-open": isDateTimeModalOpen.value,
                                        onDidDismiss: _cache[1] || (_cache[1] = () => isDateTimeModalOpen.value = false)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonContent), { "force-overscroll": false }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonDatetime), {
                                                "show-default-buttons": "",
                                                "hour-cycle": "h23",
                                                value: job.runTimeValue ? (isCustomRunTime(job.runTimeValue) ? getDateTime(job.runTimeValue) : getDateTime(_unref(DateTime).now().toMillis() + job.runTimeValue)) : getNowTimestamp(),
                                                onIonChange: ($event: any) => (updateCustomTime($event, job))
                                              }, null, 8, ["value", "onIonChange"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["is-open"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonItem), { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        slot: "start",
                                        icon: _unref(timerOutline)
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonSelect), {
                                        label: _unref(translate)('Frequency'),
                                        value: getJobStatus(job),
                                        placeholder: _unref(translate)('Select'),
                                        interface: "popover",
                                        onIonDismiss: ($event: any) => (updateFrequency($event, job))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobFrequencyOptions.value, (freq) => {
                                            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                              key: freq.id,
                                              value: freq.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(freq.description), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["label", "value", "placeholder", "onIonDismiss"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonItem), { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        slot: "start",
                                        icon: _unref(albumsOutline)
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonSelect), {
                                        label: _unref(translate)('Inventory channel'),
                                        modelValue: job.runtimeData.facilityGroupId,
                                        "onUpdate:modelValue": ($event: any) => ((job.runtimeData.facilityGroupId) = $event),
                                        disabled: job.statusId === 'SERVICE_PENDING',
                                        placeholder: _unref(translate)('Select'),
                                        interface: "popover"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inventoryChannels.value, (channel) => {
                                            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                              key: channel.facilityGroupId,
                                              value: channel.facilityGroupId
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(channel.facilityGroupName ? channel.facilityGroupName : channel.facilityGroupId), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_unref(IonButton), {
                                      fill: "clear",
                                      onClick: ($event: any) => (saveChanges(job))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("Save changes")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_unref(IonButton), {
                                      color: "medium",
                                      fill: "clear",
                                      slot: "end",
                                      onClick: ($event: any) => (openShopActionsPopover($event, job))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonIcon), {
                                          icon: _unref(ellipsisVerticalOutline),
                                          slot: "icon-only"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("p", null, _toDisplayString(_unref(translate)("No job found.")), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (selectedSegment.value === 'channels')
        ? (_openBlock(), _createBlock(_unref(IonFab), {
            key: 0,
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonFabButton), {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (openCreateGroupModal()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})